<template>
  <section>
    <h1 class="text-h3 mb-8">
      Overlays
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <v-checkbox
        v-model="absolute"
        label="Absolute"
      />
      <div class="d-flex justify-center">
        <v-btn
          color="success"
          @click="overlay = !overlay"
        >
          Show Overlay
        </v-btn>
        <v-overlay
          :value="overlay"
          :absolute="absolute"
        >
          <v-btn
            color="success"
            @click="overlay = false"
          >
            Hide Overlay
          </v-btn>
        </v-overlay>
      </div>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/overlays/">
      <strong>Overlays</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsOverlays',
  data: () => ({
    overlay: false,
    absolute: false
  })
}
</script>
